export class OtherDesignatedContact {
  role: string;
  name: string;
  title: string;
  company: string;
  address: string;
  phone: string;
  email: string;
}
